import { withStyles } from "@material-ui/core";
import {
  tesaBlue,
  tesaBlue3,
  tesaDarkGrey,
  tesaDarkRedError,
  tesaGrey1,
  tesaGrey4,
} from "../../../../../styles/colors";

export default withStyles(() => ({
  cellHeadline2: {
    color: "#757575",
    fontSize: "0.9rem",
    paddingTop: "10px",
    paddingBottom: "10px",
    marginLeft: "5px",
  },
  cursor: {
    cursor: "pointer",
  },
  testCaseButton: {
    maxHeight: "40px",
    minHeight: "40px",
  },
  highlightedRow: {
    backgroundColor: [tesaBlue3, "!important"].join(" "),
    "& .MuiTableCell-root, & .MuiListItemText-primary": {
      fontSize: "0.875rem !important",
      lineHeight: "1rem",
      paddingBottom: "0.75rem",
      paddingTop: "0.75rem",
    },
  },
  label: {
    color: tesaGrey1,
    fontFamily: "Proxima Nova Bold",
    fontSize: "0.875rem",
  },
  id: {
    width: 100,
    maxWidth: 100,
  },
  checkboxCell: {
    textAlign: "center",
  },
  noteOrAttachmentIcon: {
    cursor: "pointer",
    color: tesaDarkGrey,
  },
  table: {
    fontFamily: "Proxima Nova Bold Condensed",
  },
  tableRow: {
    "&:hover": {
      backgroundColor: [tesaBlue3, "!important"].join(" "),
      "& .MuiTableCell-root, & .MuiListItemText-primary": {
        fontSize: "0.875rem !important",
      },
      "& .nameColumn": {
        color: tesaBlue,
      },
    },
    "& .MuiTableCell-root, & .MuiListItemText-primary": {
      fontSize: "0.875rem !important",
      lineHeight: "1rem",
      maxWidth: "600px",
      paddingBottom: "0.75rem",
      paddingTop: "0.75rem",
    },
  },
  tableRowInvalid: {
    "& .MuiTableCell-root, & .MuiListItemText-primary": {
      color: tesaDarkRedError,
      fontWeight: "bold",
    },
  },
  whiteChip: {
    marginRight: "5px",
    marginTop: "5px",
  },
  testCasesCheckBox: {
    padding: 0,
  },
  progressBar: {
    width: "40px",
    height: "20px",
    backgroundColor: tesaGrey4,
  },
}));
